<template>
  <v-card class="px-6 pt-5" flat>
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tab-item>
          <nfc-orders-list />
        </v-tab-item>
        <v-tab-item>
          <equipment-list />
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import nfcOrdersList from "./nfcOrdersList.vue";
import equipmentList from "./equipmentList.vue";
export default {
  name: "orderList",
  components: { nfcOrdersList, equipmentList },
  data() {
    return {
      tabItems: [
        {
          text: this.$t('nfc_physical_card_orders'),
          icon: "nfc",
          value: "nfcOrdersList",
        },
        {
          text: this.$t('buy_equipment'),
          icon: "palette-swatch",
          value: "equipmentList",
        },
      ],
      tabs: null,
    };
  },
};
</script>

<style></style>
